// Keeps a marquee's scroll speed constant regardless of how many items it holds.
// Markup carries the item count (data-marquee) and seconds-per-item (data-per-logo);
// the animation-duration is derived from them so the per-item speed stays fixed.
export default function initMarquee() {
  const marquees = document.querySelectorAll("[data-marquee]")

  marquees.forEach((el) => {
    const count = parseInt(el.dataset.marquee, 10)
    const perItem = parseFloat(el.dataset.perLogo)

    if (!count || !perItem) return

    el.style.animationDuration = `${count * perItem}s`
  })
}
